import {
    buildIdentifierBlock,
    formatCopyGroupTitle,
    formatCopySections,
} from '@/utils/encounterCopyUtils';

const DEFAULT_CARE_PLAN_CATEGORIES = [
    'perform',
    'medication',
    'treatment_instructions',
    'referral',
    'return_reevaluation',
    'follow_up_visit',
];

function uniqueTreatmentsByName(treatments) {
    const seenNames = new Set();
    return treatments.filter(treatment => {
        if (seenNames.has(treatment.name)) return false;
        seenNames.add(treatment.name);
        return true;
    });
}

function buildCarePlanCopyPayload({
    identifiers = [],
    translate,
    riskSections = [],
    carePlanSections = [],
    additionalContext = '',
    additionalContextLabel = '',
    riskTitle = 'Risk Assessments',
    carePlanTitle = 'Care Plan',
    rtl = false,
} = {}) {
    const formattedRisks = formatCopySections(riskSections);
    const formattedCarePlan = formatCopySections(carePlanSections);
    const trimmedContext = String(additionalContext || '').trim();

    if (trimmedContext) {
        formattedCarePlan.push(`${additionalContextLabel.toUpperCase()}\n${trimmedContext}`);
    }

    const sections = [buildIdentifierBlock(identifiers, translate)];
    if (formattedRisks.length > 0) {
        sections.push(formatCopyGroupTitle(riskTitle), ...formattedRisks);
    }
    if (formattedCarePlan.length > 0) {
        sections.push(formatCopyGroupTitle(carePlanTitle), ...formattedCarePlan);
    }

    const payload = sections
        .filter(Boolean)
        .join('\n\n')
        .trim();

    return rtl && payload ? `\u200F${payload}` : payload;
}

export { DEFAULT_CARE_PLAN_CATEGORIES, buildCarePlanCopyPayload, uniqueTreatmentsByName };
